import styled from "styled-components";

export const LoanCalculatorWrapper = styled.div`
  width: 90%;
  max-width: 900px;
  margin: 6rem auto;
  padding: 6rem 0 2rem 0;
  min-height: calc(100vh - 260px);

  .card {
    background: ${({ theme }) => theme.colors?.grey01};
    border: 1px solid ${({ theme }) => theme.colors?.grey02};
    border-radius: 8px;
    padding: 2.4rem;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  }

  h1 {
    margin: 0 0 0.5rem;
    color: ${({ theme }) => theme.colors?.side};
  }

  .subtitle {
    margin: 0 0 2rem;
  }

  form {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1.2rem;
  }

  label {
    font-weight: 600;
    margin-bottom: 0.4rem;
    display: block;
  }

  select {
    width: 100%;
    max-width: 560px;
    border: 1px solid grey;
    outline: none;
    font-size: 1.5rem;
    border-radius: 4px;
    padding: 1.08rem;
    box-sizing: border-box;
    background-color: ${({ theme }) => theme.colors?.grey01};
  }

  .result {
    margin-top: 2rem;
    padding: 1.4rem;
    border-radius: 6px;
    background: ${({ theme }) => theme.colors?.side};
    color: ${({ theme }) => theme.colors?.white};
  }

  .result p {
    margin: 0.5rem 0;
  }

  .result h3 {
    margin: 1rem 0 0.3rem;
    color: ${({ theme }) => theme.colors?.white};
  }

  .result h3:first-child {
    margin-top: 0;
  }

  .error {
    margin-top: 1rem;
    color: ${({ theme }) => theme.colors?.red};
    font-weight: 600;
  }

  @media screen and (max-width: 790px) {
    width: 95%;
    padding-top: 8rem;
    min-height: calc(100vh - 220px);
  }
`;
